import useGetReports from 'workflow/common/hooks/useGetReports'

import { colCount } from '../../common/constants'

export type ReportsData = Record<string, string | number | null> | undefined

export interface ResultColumn {
  title: string
  key: string
  dataIndex: string
  value?: string | number | null
}

interface ResultValue {
  [key: string]: string | number
}

export type ResultsData = {
  columns: ResultColumn[]
  values: ResultValue[]
} | null

export type ShowMachineOpensTicked = boolean | undefined

export const getResults = (results: ResultsData) => {
  const resultsCollection = (
    results?.columns.filter(({ key, dataIndex }) => {
      const value = results && results.values[0][dataIndex]
      return key !== 'variant' && value
    }) ?? []
  ).map((item) => {
    return {
      ...item,
      value: results?.values[0][item.dataIndex],
    }
  })

  return {
    resultsCollection,
    resultsCellCount: resultsCollection.length,
  }
}

export const getWinnerColSpan = (
  reportsCellCount: number,
  totalCellCount: number
) => {
  const hasOneDataRow = totalCellCount <= colCount
  const hasReportsDataInWinnerRow = !hasOneDataRow && reportsCellCount <= 2

  return {
    winnerColSpan: hasReportsDataInWinnerRow
      ? colCount - reportsCellCount
      : colCount,
    hasOneDataRow,
    hasReportsDataInWinnerRow,
  }
}

const useWinnerVariantInfo = ({ reports, results, showMachineOpensTicked }) => {
  const { hasReportsData, reportsCollection, reportsCellCount } = useGetReports(
    {
      reports,
      showMachineOpensTicked,
    }
  )

  const hasResultsData = !!results

  const winnerVariant = results && results.values[0]['variant']

  const { resultsCellCount, resultsCollection } = getResults(results)

  const totalCellCount = resultsCellCount + reportsCellCount

  const { winnerColSpan, hasOneDataRow, hasReportsDataInWinnerRow } =
    getWinnerColSpan(reportsCellCount, totalCellCount)

  const emptyReportsCellCount =
    hasOneDataRow || hasReportsDataInWinnerRow ? 0 : colCount - reportsCellCount

  const emptyResultsCellCount = hasOneDataRow
    ? colCount - totalCellCount
    : colCount - resultsCellCount

  return {
    hasResultsData,
    hasReportsData,
    winnerVariant,
    reportsCellCount,
    reportsCollection,
    resultsCollection,
    winnerColSpan,
    emptyReportsCellCount,
    emptyResultsCellCount,
  }
}

export default useWinnerVariantInfo
